import { TooltipPropertiesType } from "@website/ui/tooltip/tooltip.types";
import pick from "lodash-es/pick";
import { useCallback, useEffect, useRef } from "react";

export const useTooltip = (properties: TooltipPropertiesType) => {
  const { title } = properties;
  const contentReference = useRef<HTMLDivElement>(null);

  const escFunction = useCallback((event: KeyboardEvent) => {
    if (event.key === "Escape" && contentReference.current) {
      contentReference.current.blur();
      event.stopPropagation();
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction);

    return () => {
      document.removeEventListener("keydown", escFunction);
    };
  }, [escFunction]);

  return {
    tooltipProperties: {
      ref: contentReference,
      "aria-label": title
    },
    titleProperties: {
      ...pick(properties, "id"),
      role: "tooltip"
    }
  };
};
